<template>
  <div class="sidebarOverlay">
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.sidebarOverlay {
  display: flex;
  flex-direction: column;
  padding: rem(56px) 0;
  justify-content: center;
  top: 0;
  position: absolute;
  width: rem($sidebar-width);
  bottom: 0;
  left: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--c__bg);
  .content {
    margin: auto 0;
  }
}
:deep(h2) {
  font-weight: bold;
  text-align: center;
  @include type-size('medium');
}
</style>
